import { useQuery } from 'react-query';
import { queryAllPlansENT } from './usePlansENT.query';
import { UsePlansENTOptions } from './usePlansENT.types';
import { PlanENT } from '../../../types/models/plans/plans.types';

export const ALL_PLANS_ENT_QUERY_KEY = 'ALL_PLANS_ENT';

export const usePlansENT = (options?: UsePlansENTOptions) => {
  return useQuery<PlanENT[], Error>(ALL_PLANS_ENT_QUERY_KEY, () => queryAllPlansENT(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
